
import React, { Component } from 'react'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import IconMenu from 'material-ui/IconMenu'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router'
import Colors from 'material-ui/styles/colors'
import {List, ListItem} from 'material-ui/List'

import Avatar from 'material-ui/Avatar'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'



import FlatButton from 'material-ui/FlatButton'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import { beautifyPhone } from 'utils/stuff'

import StarsRating from './StarsRating'


export default (o) => {
return(
	(!o.repairman)? <div></div>
	:<div
		key={`repairmen-${o.id}`}
		style={{
			margin: "4pt 30pt 4pt 0"
		}}
	>
		<Card
			key={`repairmen-${o.id}`}
			style={{
				paddingLeft: (typeof global.md.phone() == 'string')?"10px":"auto"
			}}
		>
			<CardHeader
				title={
					<div
						style={{
							overflow: "hidden"
						  , textOverflow: "ellipsis"
						  , whiteSpace: "nowrap"
						  , display: "inline-block"
						  , verticalAlign: "middle"
						  , marginLeft: "0"
						  , width: "100%"
						}}
					>

						{(o.repairman.categories && o.repairman.categories.length)?
							<p style={{
									fontSize: "12px"
								  , clear: "left"
								  , width: "300px"
								  , position: "relative"
								  , paddingLeft: "0px"
								  , margin: '0'
								  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?'10px':'-4px'
								  , float: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "none" : 'right'
								  , color: "#000000"
								  , fontWeight: "400"
								  , whiteSpace: "nowrap"
								  , lineHeight: "77px"
								  , height: "77px"
								  , overflow: "hidden"
								  , textOverflow: "ellipsis"
								  , maxWidth: "100%"
								}}
							>
								Categories: {o.repairman.categories.map((category, indx, arr) =>
									<span
										style={{
											verticalAlign: "middle"
										}}
									>
										{(indx == 0)?
											category
											: (arr && indx == arr.length -1)?
												` and ${category}`
												: `, ${category}`
										}
									</span>
								)}
							</p>
						: <p style={{fontSize: "12px", clear: "left", position: "relative", paddingLeft: "0px", margin: '0', color: "#000000"}}>No categories</p>}
						<p
							style={{
								fontSize: "14px"
							}}
						>
							{`${o.repairman.firstName}`}
						</p>

					</div>

				}
				style={{
					paddingLeft: "3px"
				  , height: "78px"
				}}
				textStyle={{
					marginTop: '-15px'
				  , height: "35px"
				  , fontWeight: "800"
				  , width: "50%"
				}}
				actAsExpander={true}
				showExpandableButton={true}
				avatar={(typeof global.md.phone() != "string")?
						<img
							src={'/' + process.env.REACT_APP_NAME + "/static/img/yelp.png"}
							style={{
								float: "left"
							  , marginLeft: "27px"
							}}
						/>
						: <div style={{display: "none"}}></div>
				}
			>
				{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
					<div style={{
							float: "clear"
						  , color: "#009be1"
						  , marginTop: "-19px"
						  , width: "60%"
						}}
					>
							<div style={{
									float: 'right'
								}}>
								<p>
									{(o.repairman.distance)? o.repairman.distance : ''} miles
								</p>
							</div>
							<br/>
							<StarsRating style={{
									float: "none"
								  , marginTop:"-3px"
								}}
								scheme="blue"
								size = "18px"
								value = {(o.repairman.rating)?o.repairman.rating:"0"}
							/>
					</div>
					:
					<div style={{
							float: "clear"
						  , color: "#009be1"
						  , lineHeight: "20px"
						  , width: "60%"
						}}
					>
						<StarsRating style={{
								verticalAlign: "middle"
							  , display: "inline-block"
							}}
							scheme="blue"
							size = "12px"
							value = {(o.repairman.rating)?o.repairman.rating:"0"}
						/>
						<div style={{
								float: 'none'
							  , verticalAlign: "middle"
							  , display: "inline-block"
							}}>
							<p
								style={{
									margin: "0"
								}}
							>
								{(o.repairman.distance)? o.repairman.distance : ''} miles
							</p>
						</div>
					</div>
				}
			</CardHeader>
			<CardText expandable={true}>

				{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
					<div>
						<a
							href={o.repairman.web}
							target="_blank"
							style={{
								width:"45%"
							  , margin:"0 2.5%"
							  , border:"2px solid #009be1"
							  , display:"inline-block"
							  , height:"35px"
							  , lineHeight:"35px"
							  , textAlign:"center"
							  , textDecoration:"none"
							  , color:"#009be1"
							  , borderRadius:"6px"
							}}
						>
							YELP PROFILE
						</a>
						<span
							style={{
								width:"45%"
							  , margin:"0 2.5%"
							  , border:"2px solid #009be1"
							  , display:"inline-block"
							  , height:"35px"
							  , lineHeight:"35px"
							  , textAlign:"center"
							  , textDecoration:"none"
							  , color:"#FFF"
							  , backgroundColor : "#009be1"
							  , borderRadius:"6px"
								, cursor: 'pointer'
							}}
							onClick={() => {
								let id = new Date().valueOf().toString()
								o.docUpd({
										_id: id
									  , firstName: o.repairman.firstName
									  , lastName: ""
									  , phoneNumber: beautifyPhone(o.repairman.phoneNumber)
									  , cellNumber: ""
									  , email: ""
									  , address: o.repairman.address
									  , categories: o.repairman.categories
									  , note: o.repairman.note
									  , type: (o.type != 'Agent')? "repairman" : 'agent'
									  , rating: o.repairman.rating
									  , tasks: []
									  , cors: o.repairman.cors
									  , history: [{
											userID: o.userID
										  , action: 'import'
										  , date: new Date().valueOf()
										}]
								})
								// o.history.pushState(null, `/repairmen/${id}`)
							}}
						>
							ADD
						</span>
					</div>
					:
					<div>
						<a
							href={o.repairman.web}
							target="_blank"
							style={{
								width:"140px"
							  , marginLeft:"50px"
							  , border:"2px solid #009be1"
							  , display:"inline-block"
							  , height:"35px"
							  , lineHeight:"35px"
							  , textAlign:"center"
							  , textDecoration:"none"
							  , color:"#009be1"
							  , borderRadius:"6px"
							}}
						>
							YELP PROFILE
						</a>
						<span
							style={{
								width:"140px"
							  , margin:"0 2.5%"
							  , border:"2px solid #009be1"
							  , display:"inline-block"
							  , height:"35px"
							  , lineHeight:"35px"
							  , textAlign:"center"
							  , textDecoration:"none"
							  , color:"#FFF"
							  , backgroundColor : "#009be1"
							  , borderRadius:"6px"
								, cursor: "pointer"
							}}
							onClick={() => {
								let id = new Date().valueOf().toString()
								o.docUpd({
										_id: id
									  , firstName: o.repairman.firstName
									  , lastName: ""
									  , phoneNumber: beautifyPhone(o.repairman.phoneNumber)
									  , cellNumber: ""
									  , email: ""
									  , address: o.repairman.address
									  , categories: o.repairman.categories
									  , note: o.repairman.note
									  , type: (o.type != 'Agent')? "repairman" : 'agent'
									  , rating: o.repairman.rating
									  , tasks: []
									  , cors: o.repairman.cors
									  , history: [{
											userID: o.userID
										  , action: 'import'
										  , date: new Date().valueOf()
										}]
								})
								// o.history.pushState(null, `/repairmen/${id}`)
							}}
						>
							ADD
						</span>
					</div>
				}

			</CardText>
		</Card>
		{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
			<Divider inset={true} style={{padding: "1"}} />
			: ""
		}
	</div>
)}
// <div
// 	style={{
// 		marginTop: "5px"
// 	  , borderRadius: "25px"
// 	  , width: "45px"
// 	  , height: "45px"
// 	  , borderStyle: "solid"
// 	  , float: "left"
// 	  , borderColor:
// 		(o.repairman.tasksActive && o.repairman.tasksActive.length)?
// 			Colors.darkBlack
// 			:(!o.repairman.retired)?
// 					Colors.green500
// 					:Colors.grey500
// 	}}
// >
// 	<FloatingActionButton
// 		onClick={() => {
// 			let id = new Date().valueOf().toString()
// 			o.docUpd({
// 					_id: id
// 				  , firstName: o.repairman.firstName
// 				  , lastName: ""
// 				  , phoneNumber: beautifyPhone(o.repairman.phoneNumber)
// 				  , cellNumber: ""
// 				  , email: ""
// 				  , address: o.repairman.address
// 				  , categories: o.repairman.categories
// 				  , note: o.repairman.note
// 				  , type: (o.type != 'Agent')? "repairman" : 'agent'
// 				  , rating: o.repairman.rating
// 				  , tasks: []
// 				  , cors: o.repairman.cors
// 				  , history: [{
// 						userID: o.userID
// 					  , action: 'import'
// 					  , date: new Date().valueOf()
// 					}]
// 			})
// 			// o.history.pushState(null, `/repairmen/${id}`)
// 		}}
// 		secondary={true}
// 		mini={true}>
// 		<ContentAdd />
// 	</FloatingActionButton>
// </div>
// , marginTop: "-20px";
// height: 50px;



// WEBPACK FOOTER //
// ./src/components/RepairmanCardYelp.js